export const menuItems = [
    {
        id: 1,
        label: "Dashboard",
        icon: "bx-home-circle",
        link: "/admin/dashboard"
    },
    {
        id: 2,
        label: 'Client Management',
        icon: "bx bxs-user-detail",
        subItems: [
            {
                id: 3,
                label: "Create Enterprise Partner",
                link: "/",
                parentId: 2
            },
            {
                id: 4,
                label: "Enterprise Partners",
                link: "/dashboard/saas",
                parentId: 2
            },
            {
                id: 5,
                label: "Create Tax Company",
                link: "/dashboard/crypto",
                parentId: 2
            },
            {
                id: 6,
                label: "Tax Companies",
                link: "/dashboard/blog",
                parentId: 2
            },
            {
                id: 7,
                label: "Create Tax Payer",
                link: "/dashboard/blog",
                parentId: 2
            },
            {
                id: 8,
                label: "Tax Payers",
                link: "/dashboard/blog",
                parentId: 2
            },
            {
                id: 9,
                label: "All Clients",
                link: "/dashboard/blog",
                parentId: 2
            }
        ]
    },
    {
        id: 10,
        label: "Email Campaigns",
        icon: "bx bx-envelope",
        link: "/admin/dashboard"
    },
    {
        id: 11,
        label: "Messsages",
        icon: "bx bx-chat",
        link: "/admin/dashboard"
    },
    {
        id: 12,
        label: 'Document Manager',
        icon: "bx bx-file",
        subItems: [
            {
                id: 13,
                label: "Folders",
                link: "/",
                parentId: 12
            },
            {
                id: 14,
                label: "E-Signatures",
                link: "/",
                parentId: 12
            }
        ]
    },
    {
        id: 15,
        label: "Task Management",
        icon: "bx bx-task",
        link: "/admin/dashboard"
    },
    {
        id: 16,
        label: "Schedule",
        icon: "bx bx-calendar",
        link: "/admin/dashboard"
    },
    {
        id: 17,
        label: "Invoices",
        icon: "bx bx-receipt",
        link: "/admin/dashboard"
    },
];
